import React, { useCallback, useState } from "react";
import { Card, Button, Col, Row, CardBody, CardFooter } from "reactstrap";
import closeOutline from "../../../assets/icons/close-outline.svg";
import report from "../../../assets/icons/report.svg";
import { Checkbox } from "cfa-react-components";
import I18n from "../../../../i18n/utils";
import CFASpinner from "../../Common/CFASpinnner/CFASpinner";
import "./riskInformationExportModal.scss";

const RiskInformationExportModal: React.FC<any> = ({
  close,
  gridApi,
  loading,
}: any): JSX.Element => {
  const closeModal = useCallback(() => {
    close(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeSuccess = useCallback(() => {
    close(true);
  }, []);
  const [excelExport, setExcelExport] = useState<boolean>(false);

  function exportAllRows() {
    const allowedExports = [
      "locationNumber",
      "operatorName",
      "dateLastEmailOperator",
      "modelProb",
      "endTime",
      "countHighRiskScores",
      "modelDailyRank",
      "outputRefundAmount",
      "financialConsultant",
      "rcma",
    ];

    const gridParams = {
      fileName: "Sherlock_Data_Export",
      columnKeys: allowedExports,
    };

    if (excelExport) {
      gridApi.exportDataAsExcel(gridParams);
    } else {
      gridApi.exportDataAsCsv(gridParams);
    }
    close();
  }

  function exportCurrentRows() {
    const gridParams = { fileName: "Sherlock_Data_Export" };
    if (excelExport) {
      gridApi.exportDataAsExcel(gridParams);
    } else {
      gridApi.exportDataAsCsv(gridParams);
    }
    close();
  }

  const saveForm = (
    <Row>
      <Col className="dashboard-card">
        <Card className="dashboard-card">
          <CardBody>
            <Row className="close-button-container">
              <img
                alt=""
                src={closeOutline}
                className="close-modal-icon"
                onClick={close}
              />
            </Row>
            <Row className="RiskInformationExportModal container">
              <Col className="bu-override-import-title-container">
                <img
                  alt=""
                  src={report}
                  className="bu-override-import-title-icon"
                />
                <h2 className="bu-override-import-title">
                  {I18n.t("RISK_ANALYSIS_MODAL_TITLE")}
                </h2>
              </Col>
            </Row>
            <CardFooter>
              {!loading ? (
                <>
                  <Row style={{ height: "5rem" }}>
                    <Checkbox
                      checked={excelExport}
                      label="Export as Excel?"
                      onChange={() => setExcelExport(!excelExport)}
                      style={{ marginLeft: "auto", marginRight: "auto" }}
                      crossOrigin={undefined}
                      onPointerEnterCapture={undefined}
                      onPointerLeaveCapture={undefined}
                    />
                  </Row>
                  <Row>
                    <Button
                      disabled={false}
                      className="submit-button"
                      onClick={exportAllRows}
                    >
                      Export All Columns
                    </Button>
                    <Button
                      disabled={false}
                      className="submit-button"
                      onClick={exportCurrentRows}
                    >
                      Export Visible Columns
                    </Button>
                    <Button className="submit-button" onClick={closeModal}>
                      Close
                    </Button>
                  </Row>
                </>
              ) : (
                <Row className="spinner-container">
                  <CFASpinner />
                </Row>
              )}
            </CardFooter>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );

  const submissionSuccess = (
    <Col className="success-container">
      {/*           <img alt="" src={success} className="success-icon" />*/}
      <h4>{I18n.t("APP_ARMORED_CAR_IMPORT_SUCCESS")}</h4>
      <Button className="go-back-button" block onClick={closeSuccess}>
        {I18n.t("APP_ARMORED_CAR_IMPORT_FILE_CLOSE")}
      </Button>
    </Col>
  );

  return (
    <>
      <Col className="RiskInformationExportModal container">{saveForm}</Col>
    </>
  );
};
export default RiskInformationExportModal;
